/** 包含extranet域名的hostname为外网，否则为内网 */
export const isExtranetHostname = () => {
  return window.location.hostname.indexOf('extranet') !== -1
}
